export default __webpack_public_path__ + "static/media/java.9088e28f.png";